import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { UnpublishedAssignment } from '@/openapi';
import { ScheduleService } from '@/openapi';
import { queryKeys } from '@/util/queryKeys';

export const useUnpublishedAssignmentMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (assignments: UnpublishedAssignment[]) => {
      const modified = assignments.map((assignment) => ({
        id: assignment.id,
        date: assignment.date,
        shiftId: assignment.shiftId,
        points: assignment.points,
        partnerId: assignment.partnerId,
        toBeDeleted: assignment.toBeDeleted,
      }));
      return ScheduleService.scheduleServiceUpdateUnpublishedSchedule({
        body: modified,
      });
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.schedule.all });
      await queryClient.invalidateQueries({
        queryKey: queryKeys.shiftByInterval.all,
      });
    },
  });
};
